import { Announcements, CreateAnnouncement, UpdateAnnouncement } from '@/pages/Announcements'
import { AttendanceLogs } from '@/pages/AttendanceLogs'
import { CreateEmployee, Employees, EmployeesImport, UpdateEmployee } from '@/pages/Employees'
import { Home } from '@/pages/Home'
import { CreateIdCard, IdCards, IdCardsImport } from '@/pages/IdCards'
import { CreateLanguage, Languages, UpdateLanguage } from '@/pages/Languages'
import { CreateTerminal, Terminals, UpdateTerminal } from '@/pages/Terminals'
import { CreateUniform, Uniforms, UniformsImport, UpdateUniform } from '@/pages/Uniforms'

const EMPLOYEE_PATH = '/employees'
const ID_CARD_PATH = '/id-cards'
const UNIFORM_PATH = '/uniforms'
const TERMINAL_PATH = '/terminals'
const ANNOUNCEMENT_PATH = '/announcements'
const LANGUAGES_PATH = '/languages'
const ATTENDANCELOG_PATH = '/attendance-logs'
const routes = {
  attendanceLogs: {
    path: ATTENDANCELOG_PATH,
    component: AttendanceLogs,
    isPrivate: false,
  },

  employees: {
    path: EMPLOYEE_PATH,
    component: Employees,
    isPrivate: false,
  },
  updateEmployee: {
    path: `${EMPLOYEE_PATH}/:id`,
    component: UpdateEmployee,
    isPrivate: false,
  },
  createEmployee: {
    path: `${EMPLOYEE_PATH}/create`,
    component: CreateEmployee,
    isPrivate: false,
  },
  employeesImport: {
    path: `${EMPLOYEE_PATH}/import`,
    component: EmployeesImport,
    isPrivate: false,
  },
  home: {
    path: '/',
    component: Home,
    isPrivate: false,
  },
  idCards: {
    path: ID_CARD_PATH,
    component: IdCards,
    isPrivate: false,
  },
  createIdCard: {
    path: `${ID_CARD_PATH}/create`,
    component: CreateIdCard,
    isPrivate: false,
  },
  announcements: {
    path: ANNOUNCEMENT_PATH,
    component: Announcements,
    isPrivate: false,
  },
  updateAnnouncement: {
    path: `${ANNOUNCEMENT_PATH}/:id`,
    component: UpdateAnnouncement,
    isPrivate: false,
  },
  createAnnouncement: {
    path: `${ANNOUNCEMENT_PATH}/create`,
    component: CreateAnnouncement,
    isPrivate: false,
  },
  idCardsImport: {
    path: `${ID_CARD_PATH}/import`,
    component: IdCardsImport,
    isPrivate: false,
  },
  languages: {
    path: LANGUAGES_PATH,
    component: Languages,
    isPrivate: false,
  },
  updateLanguage: {
    path: `${LANGUAGES_PATH}/:id`,
    component: UpdateLanguage,
    isPrivate: false,
  },
  createLanguage: {
    path: `${LANGUAGES_PATH}/create`,
    component: CreateLanguage,
    isPrivate: false,
  },
  terminals: {
    path: TERMINAL_PATH,
    component: Terminals,
    isPrivate: false,
  },
  createTerminal: {
    path: `${TERMINAL_PATH}/create`,
    component: CreateTerminal,
    isPrivate: false,
  },
  updateTerminal: {
    path: `${TERMINAL_PATH}/:id`,
    component: UpdateTerminal,
    isPrivate: false,
  },
  uniforms: {
    path: UNIFORM_PATH,
    component: Uniforms,
    isPrivate: false,
  },
  createUniform: {
    path: `${UNIFORM_PATH}/create`,
    component: CreateUniform,
    isPrivate: false,
  },
  uniformsImport: {
    path: `${UNIFORM_PATH}/import`,
    component: UniformsImport,
    isPrivate: false,
  },
  updateUniform: {
    path: `${UNIFORM_PATH}/:id`,
    component: UpdateUniform,
    isPrivate: false,
  },
}

export default routes
